import React, { useState, useRef, useEffect } from 'react';
import styles from '../../styles/MultiSelectDropdown.module.scss';
import Caret from './Caret';
import CheckedIcon from '../../../icons/CheckedIcon';

export default function MultiSelectDropdown({
  options,
  selected,
  onToggle,
  disabled = false,
  placeholder = 'Select…',
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, [open]);

  const count = selected.size;

  // Read-only: just show chips
  if (disabled) {
    return (
      <div className={styles.chips}>
        {count === 0 && <span className={styles.placeholder}>{placeholder}</span>}
        {[...selected].map((item) => (
          <span key={item} className={styles.chip}>
            {item}
          </span>
        ))}
      </div>
    );
  }

  const triggerLabel =
    count === 0
      ? placeholder
      : count <= 2
        ? [...selected].join(', ')
        : `${count} formats selected`;

  return (
    <div className={styles.wrap} ref={ref}>
      <button
        type="button"
        className={`${styles.trigger} ${open ? styles.triggerOpen : ''}`}
        onClick={() => setOpen((o) => !o)}
      >
        <span className={count === 0 ? styles.placeholder : ''}>{triggerLabel}</span>
        <span className={styles.caret}>
          <Caret up={open} />
        </span>
      </button>

      {open && (
        <ul className={styles.dropdown} role="listbox">
          {options.map((opt) => {
            const checked = selected.has(opt);
            return (
              <li key={opt} role="option" aria-selected={checked}>
                <label className={styles.option}>
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => onToggle(opt)}
                  />
                  <span className={`${styles.box} ${checked ? styles.boxChecked : ''}`}>
                    <CheckedIcon height="13px" fill="#fff" />
                  </span>
                  <span className={styles.optionLabel}>{opt}</span>
                </label>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
